import React, { useState, useEffect, useCallback } from "react";
import InputField from "../InputField/InputField";
import { AppHelper } from "../../utils/Helper";
import { AppConfig } from "../../config";

type Option = {
  id: any;
  name: string;
  value: string;
};
type FormType = "create" | "edit";
type ProductType = "product" | "group";
type StatusType = "active" | "inactive";

interface ProductFormData {
  type: ProductType;
  sector: Object;
  category: Object;
  name: String;
  description: String;
  image: File | String;
  diet_type: Object;
  gst: Number;
  selectedMrp: {};
  mrp: [];
  status: StatusType;
}

interface ProductFormProps {
  type: FormType;
  productData?: any;
  groupData?: any;
  initialData?: Partial<ProductFormData>;
  onSubmit: (data: any) => void;
  onOpenFile: (data: any) => void;
  selectedImages: any;
  onRemoveImages: (data: any) => void;
  allCategoryData: any;
  allSectorData: any;
  allDietTypeData: any;
  imageBaseUrl: any;
  triggerBottomSheet: (data: any) => void;
  onAvailableChange: (data: any) => void;
}

type GSTFunction = (gst: number | string, value: number | string) => number;

const ProductForm: React.FC<ProductFormProps> = ({
  type,
  productData,
  groupData,
  initialData = {},
  onSubmit,
  onOpenFile,
  selectedImages,
  onRemoveImages,
  allCategoryData,
  allSectorData,
  allDietTypeData,
  imageBaseUrl,
  triggerBottomSheet,
  onAvailableChange,
}) => {
  const [form, setForm] = useState({
    sector: null as Option | null,
    category: null as Option | null,
    name: "",
    description: "",
    diet: null as Option | null,
    spec_remove: [],
    images: [],
    selected_images: [],
    removed_images: [],
    // stock: 0,
    mrp: [],
    gst: 0,
    sellingPrice: {
      withTax: 0,
      withoutTax: 0,
      taxAmount: 0,
    },
    maxSellingPrice: {
      withTax: 0,
      withoutTax: 0,
    },
    strikePrice: {
      withTax: 0,
      withoutTax: 0,
    },
    priceType: 0,
    packageCharge: {
      type: 1,
      gst: 0,
      withTax: 0,
      withoutTax: 0,
      percentage: 0,
      taxAmount: 0,
    },
    stock: {},
    inventory: [],
    inventoryBasedPrice: [],
    inventoryBasedStock: [],
    inventoryBasedStockPrice: [],
    ...initialData,
  });
  // Track which fields the user has edited
  const [touchedFields, setTouchedFields] = useState<
    Partial<Record<keyof ProductFormData, boolean>>
  >({});

  const [errors, setErrors] = useState<Record<string, string>>({});
  const [priceType, setPriceType] = useState({
    mrp: false,
    stock: false,
    inventory: false,
    price_based_inventory: false,
    stock_based_inventory: false,
  });
  const [isPriceTypeEdited, setIsPriceTypeEdited] = useState(false);
  const [viewCard, setViewCard] = useState({
    stock: false,
    inventory: false,
    inventory_with_sp: false,
    inventory_with_stock: false,
    inventory_with_stock_sp: false,
  });
  const fileInputRef = React.createRef();

  useEffect(() => {
    console.log("on view product from", form);
    console.log("on view product productData groupData,",productData, groupData);

    setPriceType((prevalue: any) => {
      if (form.mrp.length > 0) {
        prevalue.mrp = true;
      }

      if (form.priceType == 1) {
        prevalue.stock = false;
        prevalue.inventory = false;
        prevalue.price_based_inventory = false;
        prevalue.stock_based_inventory = false;
      }

      if (form.priceType == 2) {
        prevalue.stock = true;
        prevalue.inventory = false;
        prevalue.price_based_inventory = false;
        prevalue.stock_based_inventory = false;
      }

      if (form.priceType == 3) {
        prevalue.stock = false;
        prevalue.inventory = true;
        prevalue.price_based_inventory = false;
        prevalue.stock_based_inventory = false;
      }

      if (form.priceType == 4) {
        prevalue.stock = false;
        prevalue.inventory = true;
        prevalue.price_based_inventory = true;
        prevalue.stock_based_inventory = false;
      }

      if (form.priceType == 5) {
        prevalue.stock = true;
        prevalue.inventory = true;
        prevalue.price_based_inventory = false;
        prevalue.stock_based_inventory = false;
      }

      if (form.priceType == 6) {
        prevalue.stock = true;
        prevalue.inventory = true;
        prevalue.price_based_inventory = true;
        prevalue.stock_based_inventory = true;
      }

      if (form.priceType == 7) {
        prevalue.stock = true;
        prevalue.inventory = true;
        prevalue.price_based_inventory = false;
        prevalue.stock_based_inventory = true;
      }

      return { ...prevalue };
    });
  }, []);

  useEffect(() => {
    if (selectedImages.length > 0) {
      setTouchedFields((prev) => ({ ...prev, ["selectedImages"]: true }));
    }
  }, [selectedImages]);

  useEffect(() => {
    console.log("initial data :", initialData);
    setForm((prev) => {
      const updated = { ...prev };
      for (const key in initialData) {
        const field = key as keyof ProductFormData;
        if (!touchedFields[field]) {
          updated[field] = initialData[field];
        }
      }
      return updated;
    });
  }, [initialData]);

  useEffect(() => {
    setViewCard((prevalue) => {
      if (form.priceType == 1) {
        prevalue.stock = false;
        prevalue.inventory = false;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = false;
      }

      if (form.priceType == 2) {
        prevalue.stock = true;
        prevalue.inventory = false;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = false;
      }

      if (form.priceType == 3) {
        prevalue.stock = false;
        prevalue.inventory = true;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = false;
      }

      if (form.priceType == 4) {
        prevalue.stock = false;
        prevalue.inventory = false;
        prevalue.inventory_with_sp = true;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = false;
      }

      if (form.priceType == 5) {
        prevalue.stock = true;
        prevalue.inventory = true;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = false;
      }

      if (form.priceType == 6) {
        prevalue.stock = false;
        prevalue.inventory = false;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = false;
        prevalue.inventory_with_stock_sp = true;
      }

      if (form.priceType == 7) {
        prevalue.stock = false;
        prevalue.inventory = false;
        prevalue.inventory_with_sp = false;
        prevalue.inventory_with_stock = true;
        prevalue.inventory_with_stock_sp = false;
      }
      return { ...prevalue };
    });
    // setPriceType((prevalue: any) => {
    //   if (form.mrp.length > 0) {
    //     prevalue.mrp = true;
    //   }

    //   if (form.priceType == 1) {
    //     prevalue.stock = false;
    //     prevalue.inventory = false;
    //     prevalue.price_based_inventory = false;
    //     prevalue.stock_based_inventory = false;
    //   }

    //   if (form.priceType == 2) {
    //     prevalue.stock = true;
    //     prevalue.inventory = false;
    //     prevalue.price_based_inventory = false;
    //     prevalue.stock_based_inventory = false;
    //   }

    //   if (form.priceType == 3) {
    //     prevalue.stock = false;
    //     prevalue.inventory = true;
    //     prevalue.price_based_inventory = false;
    //     prevalue.stock_based_inventory = false;
    //   }

    //   if (form.priceType == 4) {
    //     prevalue.stock = false;
    //     prevalue.inventory = true;
    //     prevalue.price_based_inventory = true;
    //     prevalue.stock_based_inventory = false;
    //   }

    //   if (form.priceType == 5) {
    //     prevalue.stock = true;
    //     prevalue.inventory = true;
    //     prevalue.price_based_inventory = false;
    //     prevalue.stock_based_inventory = false;
    //   }

    //   if (form.priceType == 6) {
    //     prevalue.stock = true;
    //     prevalue.inventory = true;
    //     prevalue.price_based_inventory = true;
    //     prevalue.stock_based_inventory = true;
    //   }

    //   if (form.priceType == 7) {
    //     prevalue.stock = true;
    //     prevalue.inventory = true;
    //     prevalue.price_based_inventory = false;
    //     prevalue.stock_based_inventory = true;
    //   }

    //   return { ...prevalue };
    // });
  }, [form.priceType]);

  const getCategoryOptions = useCallback(() => {
    return allCategoryData[form.sector?.id];
  }, [form.sector]);

  const handleChange = (field: string, value: any) => {
    setTouchedFields((prev) => ({ ...prev, [field]: true }));
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = useCallback((): boolean => {
    const newErrors: Record<string, string> = {};

    if (!form.sector) {
      newErrors.sector = "Sector is required.";
    }

    if (!form.category) {
      newErrors.category = "Category is required.";
    }

    if (!form.name || form.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters.";
    }

    // if (!form.description) {
    //   newErrors.description = "Description is required.";
    // }

    // if (form.mrp.length === 0) {
    //   newErrors.mrp = "At least one MRP is required.";
    // }

    // if (form.gst) {
    //   newErrors.gst = "GST must be between 0 and 100.";
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  }, [errors]);

  const handleSubmit = () => {
    const isValid = validateForm();
    if (!isValid) return;
    // console.log("touchedFields :", touchedFields);
    let setData = {
      productDetails: false,
      priceType: false,
      packageCharge: false,
      form: form,
      priceTypeData: priceType,
      productData: productData,
      groupData: groupData,
      touchedFields: touchedFields,
      selectedImages: selectedImages,
    };
    if (
      touchedFields.category ||
      touchedFields.description ||
      touchedFields?.diet ||
      touchedFields.name ||
      touchedFields?.images ||
      touchedFields?.selectedImages
    ) {
      setData.productDetails = true;
    }

    if (touchedFields?.priceType) {
      setData.priceType = true;
    }

    if (touchedFields?.packageCharge) {
      setData.packageCharge = true;
    }

    onSubmit(setData);
  };

  const getDietOptions = useCallback(
    (get_data: any) => {
      let return_data = [{ id: 0, name: "Remove Diet Type" }];
      get_data.map((ele: any) => {
        return_data.push(ele);
      });
      return return_data;
    },
    [allDietTypeData]
  );

  const handleSectorChange = (val: Option) => {
    setForm((prev) => ({
      ...prev,
      sector: val,
      category: null, // reset category when sector changes
    }));
  };

  const onPriceTypeToggle = useCallback(
    (data: any) => {
      console.log("onPriceTypeToggle");
      setPriceType((prevalue: any) => {
        setViewCard((v_prevalue: any) => {
          setForm((f_prevalue: any) => {
            console.log("onPriceTypeToggle setPriceType :", prevalue);

            // type 1
            if (
              !prevalue.stock &&
              !prevalue.inventory &&
              !prevalue.price_based_inventory &&
              !prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = false;
              // v_prevalue.inventory = false;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 1;
            }

            // type 2
            if (
              prevalue.stock &&
              !prevalue.inventory &&
              !prevalue.price_based_inventory &&
              !prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = true;
              // v_prevalue.inventory = false;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 2;
            }

            // type 3
            if (
              !prevalue.stock &&
              prevalue.inventory &&
              !prevalue.price_based_inventory &&
              !prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = false;
              // v_prevalue.inventory = true;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 3;
            }

            // type 4
            if (
              !prevalue.stock &&
              prevalue.inventory &&
              prevalue.price_based_inventory &&
              !prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = false;
              // v_prevalue.inventory = false;
              // v_prevalue.inventory_with_sp = true;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 4;
            }

            // type 5
            if (
              prevalue.stock &&
              prevalue.inventory &&
              !prevalue.price_based_inventory &&
              !prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = true;
              // v_prevalue.inventory = true;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 5;
            }

            // type 6
            if (
              prevalue.stock &&
              prevalue.inventory &&
              prevalue.price_based_inventory &&
              prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = false;
              // v_prevalue.inventory = false;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = false;
              // v_prevalue.inventory_with_stock_sp = true;
              f_prevalue.priceType = 6;
            }

            // type 7
            if (
              prevalue.stock &&
              prevalue.inventory &&
              !prevalue.price_based_inventory &&
              prevalue.stock_based_inventory
            ) {
              // v_prevalue.stock = false;
              // v_prevalue.inventory = false;
              // v_prevalue.inventory_with_sp = false;
              // v_prevalue.inventory_with_stock = true;
              // v_prevalue.inventory_with_stock_sp = false;
              f_prevalue.priceType = 7;
            }

            setTouchedFields((prev) => ({ ...prev, ["priceType"]: true }));
            console.log("onPriceTypeToggle setViewCard :", v_prevalue);
            console.log("onPriceTypeToggle setForm :", f_prevalue);

            return { ...f_prevalue };
          });
          return { ...v_prevalue };
        });
        return { ...prevalue };
      });
    },
    [priceType]
  );

  const showSellingPrice = useCallback(
    (getData) => {
      let return_data = true;
      // if (get_data.edited_price_type.id == "1") {
      //   return_data = false;
      // }
      // if (get_data.edited_price_type.id == "2") {
      //   return_data = false;
      // }
      // if (get_data.edited_price_type.id == "3") {
      //   return_data = false;
      // }
      // if (get_data.edited_price_type.id == "4") {
      //   return_data = true;
      // }
      // if (get_data.edited_price_type.id == "5") {
      //   return_data = false;
      // }
      // if (get_data.edited_price_type.id == "6") {
      //   return_data = true;
      // }
      if (getData.priceType === 4 || getData.priceType === 6) {
        return_data = false;
      }
      return return_data;
    },
    [form.priceType]
  );

  const getForwardGst: GSTFunction = useCallback(
    (gst: number | string, value: number | string): number => {
      const numericValue = parseFloat(value as string);
      const numericGst = parseFloat(gst as string);

      if (isNaN(numericValue) || isNaN(numericGst)) return 0;

      let gstAmount = (numericValue * numericGst) / 100;
      return numericValue + gstAmount;
    },
    [form.gst, form.selectedMrp]
  );

  const getGstAmount: GSTFunction = useCallback(
    (gst: number | string, value: number | string): number => {
      const numericValue = parseFloat(value as string);
      const numericGst = parseFloat(gst as string);

      if (isNaN(numericValue) || isNaN(numericGst)) return 0;

      let gstAmount = (numericValue * numericGst) / 100;
      return gstAmount;
    },
    [form.gst, form.selectedMrp]
  );

  const getReverseGst: GSTFunction = useCallback(
    (gst: number | string, value: number | string): number => {
      const numericValue = parseFloat(value as string);
      const numericGst = parseFloat(gst as string);

      if (isNaN(numericValue) || isNaN(numericGst)) return 0;

      let gstPercent = 100 / (100 + numericGst);
      let taxAmount = numericValue * gstPercent;
      let gstAmount = numericValue - taxAmount;
      return numericValue - gstAmount;
    },
    [form.gst, form.selectedMrp]
  );

  const onSellingPriceChange = useCallback(
    (getData: { from: string; value: string | number }) => {
      setForm((prevForm) => {
        const updatedForm = { ...prevForm };
        const updatedErrors = { ...errors };

        const gstValue = parseFloat(prevForm.gst as any) || 0;
        const selectedMrp = parseFloat(prevForm?.selectedMrp?.mrp as any) || 0;
        const inputValue = parseFloat(getData.value as string);

        // Allow empty input
        const isEmpty = getData.value === "" || isNaN(inputValue);

        if (getData.from === "selling_price_without_tax") {
          updatedForm.sellingPrice.withoutTax = Number(getData.value);

          if (isEmpty) {
            updatedForm.sellingPrice.withTax = Number("");
            updatedErrors.selling_price_without_tax = "";
            updatedErrors.selling_price_with_tax = "";
          } else {
            const amountWithTax = getForwardGst(gstValue, inputValue);
            updatedForm.sellingPrice.withTax = Number(amountWithTax.toFixed(2));
            // const gstAmount = getGstAmount(gstValue, inputValue);
            // updatedForm.sellingPrice.taxAmount = Number(gstAmount.toFixed(2));

            if (selectedMrp > 0 && amountWithTax > selectedMrp) {
              updatedErrors.selling_price_without_tax = `Max : ${getReverseGst(
                gstValue,
                selectedMrp
              ).toFixed(2)}`;
              updatedErrors.selling_price_with_tax = `Max : ${selectedMrp.toFixed(
                2
              )}`;
            } else {
              updatedErrors.selling_price_without_tax = "";
              updatedErrors.selling_price_with_tax = "";
            }
          }
        }

        if (getData.from === "selling_price_with_tax") {
          updatedForm.sellingPrice.withTax = Number(getData.value);

          if (isEmpty) {
            updatedForm.sellingPrice.withoutTax = Number("");
            updatedErrors.selling_price_with_tax = "";
            updatedErrors.selling_price_without_tax = "";
          } else {
            const amountWithoutTax = getReverseGst(gstValue, inputValue);
            updatedForm.sellingPrice.withoutTax = Number(
              amountWithoutTax.toFixed(2)
            );

            if (selectedMrp > 0 && inputValue > selectedMrp) {
              updatedErrors.selling_price_with_tax = `Max : ${selectedMrp.toFixed(
                2
              )}`;
              updatedErrors.selling_price_without_tax = `Max : ${getReverseGst(
                gstValue,
                selectedMrp
              ).toFixed(2)}`;
            } else {
              updatedErrors.selling_price_with_tax = "";
              updatedErrors.selling_price_without_tax = "";
            }
          }
        }

        // Set errors correctly
        setErrors(updatedErrors);
        return updatedForm;
      });
    },
    [errors, getForwardGst, getReverseGst]
  );

  const onStrikePriceChange = useCallback(
    (getData: { from: string; value: string | number }) => {
      setForm((prevForm) => {
        const updatedForm = { ...prevForm };
        const updatedErrors = { ...errors };

        const gstValue = parseFloat(prevForm.gst as any) || 0;
        const selectedMrp = parseFloat(prevForm?.selectedMrp?.mrp as any) || 0;
        const inputValue = parseFloat(getData.value as string);

        // Allow empty input
        const isEmpty = getData.value === "" || isNaN(inputValue);

        if (getData.from === "strike_price_without_tax") {
          updatedForm.strikePrice.withoutTax = Number(getData.value);

          if (isEmpty) {
            updatedForm.strikePrice.withTax = Number("");
            updatedErrors.strike_price_without_tax = "";
            updatedErrors.strike_price_with_tax = "";
          } else {
            const amountWithTax = getForwardGst(gstValue, inputValue);
            updatedForm.strikePrice.withTax = Number(amountWithTax.toFixed(2));

            if (amountWithTax < updatedForm.sellingPrice.withoutTax) {
              updatedErrors.strike_price_without_tax = `* Strike price must be higher than selling price`;
              updatedErrors.strike_price_with_tax = `* Strike price must be higher than selling price`;
            } else {
              updatedErrors.strike_price_without_tax = "";
              updatedErrors.strike_price_with_tax = "";
            }
          }
        }

        if (getData.from === "strike_price_with_tax") {
          updatedForm.strikePrice.withTax = Number(getData.value);

          if (isEmpty) {
            updatedForm.strikePrice.withoutTax = Number("");
            updatedErrors.strike_price_with_tax = "";
            updatedErrors.strike_price_without_tax = "";
          } else {
            const amountWithoutTax = getReverseGst(gstValue, inputValue);
            updatedForm.strikePrice.withoutTax = Number(
              amountWithoutTax.toFixed(2)
            );

            if (inputValue < updatedForm.sellingPrice.withTax) {
              updatedErrors.strike_price_with_tax = `* Strike price must be higher than selling price`;
              updatedErrors.strike_price_without_tax = `* Strike price must be higher than selling price`;
            } else {
              updatedErrors.strike_price_with_tax = "";
              updatedErrors.strike_price_without_tax = "";
            }
          }
        }

        // Set errors correctly
        setErrors(updatedErrors);
        return updatedForm;
      });
    },
    [errors, getForwardGst, getReverseGst]
  );

  const onPackagePriceChange = useCallback(
    (getData: { from: string; value: string | any }) => {
      setForm((prevalue) => {
        if (getData.from == "gst") {
          prevalue.packageCharge.gst = getData?.value;
          let gstValue = getData.value;
          if (prevalue.packageCharge.type == 2) {
            if (gstValue > 0) {
              if (prevalue.packageCharge.withoutTax > 0) {
                const amountWithTax = getForwardGst(
                  gstValue,
                  prevalue.packageCharge.withoutTax
                );
                prevalue.packageCharge.withTax = Number(
                  amountWithTax.toFixed(2)
                );
              }
            } else {
              if (prevalue.packageCharge.withoutTax > 0) {
                const amountWithTax = getForwardGst(
                  String(prevalue.gst),
                  prevalue.packageCharge.withoutTax
                );
                prevalue.packageCharge.withTax = Number(
                  amountWithTax.toFixed(2)
                );
              }
            }
          } else {
            if (prevalue.packageCharge.percentage > 0) {
              if (prevalue.sellingPrice.withoutTax > 0) {
                let percentage_value: any =
                  (prevalue.packageCharge.percentage / 100) *
                  prevalue.sellingPrice.withoutTax;
                if (gstValue > 0) {
                  const amountWithTax = getForwardGst(
                    gstValue,
                    percentage_value
                  );
                  prevalue.packageCharge.withTax = Number(
                    amountWithTax.toFixed(2)
                  );
                  prevalue.packageCharge.withoutTax =
                    percentage_value.toFixed(2);
                } else {
                  const amountWithTax = getForwardGst(
                    String(prevalue.gst),
                    percentage_value
                  );
                  prevalue.packageCharge.withTax = Number(
                    amountWithTax.toFixed(2)
                  );
                  prevalue.packageCharge.withoutTax =
                    percentage_value.toFixed(2);
                }
              }
            } else {
              prevalue.packageCharge.withTax = 0;
              prevalue.packageCharge.withoutTax = 0;
            }
          }
        }
        if (getData.from == "percentage") {
          prevalue.packageCharge.percentage = getData.value;
          if (prevalue.sellingPrice.withoutTax > 0) {
            let percentage_value: any =
              (prevalue.packageCharge.percentage / 100) *
              prevalue.sellingPrice.withoutTax;
            if (prevalue.packageCharge.gst > 0) {
              const amountWithTax = getForwardGst(
                prevalue.packageCharge.gst,
                percentage_value
              );
              prevalue.packageCharge.withTax = Number(amountWithTax.toFixed(2));
              prevalue.packageCharge.withoutTax = Number(
                percentage_value.toFixed(2)
              );
            } else {
              const amountWithTax = getForwardGst(
                String(prevalue.gst),
                percentage_value
              );
              prevalue.packageCharge.withTax = Number(amountWithTax.toFixed(2));
              prevalue.packageCharge.withoutTax = Number(
                percentage_value.toFixed(2)
              );
            }
          }
        }
        if (getData.from == "withoutTax") {
          if (prevalue.packageCharge.type == 2) {
            prevalue.packageCharge.withoutTax = getData.value;
            if (prevalue.packageCharge.gst > 0) {
              const amountWithTax = getForwardGst(
                prevalue.packageCharge.gst,
                getData.value
              );
              prevalue.packageCharge.withTax = Number(amountWithTax.toFixed(2));
            } else {
              const amountWithTax = getForwardGst(
                String(prevalue.gst),
                getData.value
              );
              prevalue.packageCharge.withTax = Number(amountWithTax.toFixed(2));
            }
          }
        }
        if (getData.from == "withTax") {
          if (prevalue.packageCharge.type == 2) {
            prevalue.packageCharge.withTax = getData.value;
            if (prevalue.packageCharge.gst > 0) {
              const amountWithoutTax = getReverseGst(
                prevalue.packageCharge.gst,
                getData.value
              );
              prevalue.packageCharge.withoutTax = Number(
                amountWithoutTax.toFixed(2)
              );
            } else {
              const amountWithoutTax = getReverseGst(
                String(prevalue.gst),
                getData.value
              );
              prevalue.packageCharge.withoutTax = Number(
                amountWithoutTax.toFixed(2)
              );
            }
          }
        }
        setTouchedFields((prev) => ({ ...prev, ["packageCharge"]: true }));
        return { ...prevalue };
      });
    },
    [form, getForwardGst, getReverseGst]
  );

  const onGstChange = useCallback(
    (getData: any) => {
      setForm((prevForm) => {
        let updatedForm = { ...prevForm };
        let updatedErrors = { ...errors };

        updatedForm.gst = getData.value;
        if (updatedForm.sellingPrice.withTax > 0) {
          const amountWithoutTax = getReverseGst(
            String(updatedForm.gst),
            updatedForm.sellingPrice.withTax
          );
          updatedForm.sellingPrice.withoutTax = Number(
            amountWithoutTax.toFixed(2)
          );

          if (prevForm?.selectedMrp?.mrp > 0) {
            const selectedMrp =
              parseFloat(prevForm?.selectedMrp?.mrp as any) || 0;
            if (
              selectedMrp > 0 &&
              updatedForm.sellingPrice.withTax > selectedMrp
            ) {
              updatedErrors.selling_price_without_tax = `Max : ${getReverseGst(
                String(updatedForm.gst),
                selectedMrp
              ).toFixed(2)}`;
              updatedErrors.selling_price_with_tax = `Max : ${selectedMrp.toFixed(
                2
              )}`;
            } else {
              updatedErrors.selling_price_without_tax = "";
              updatedErrors.selling_price_with_tax = "";
              updatedErrors.strike_price_without_tax = "";
              updatedErrors.strike_price_with_tax = "";
            }
          } else {
            updatedErrors.selling_price_without_tax = "";
            updatedErrors.selling_price_with_tax = "";
            updatedErrors.strike_price_without_tax = "";
            updatedErrors.strike_price_with_tax = "";
          }
        }
        if (updatedForm.strikePrice.withTax > 0) {
          const amountWithoutTax = getReverseGst(
            String(updatedForm.gst),
            updatedForm.strikePrice.withTax
          );
          updatedForm.strikePrice.withoutTax = Number(
            amountWithoutTax.toFixed(2)
          );

          updatedErrors.strike_price_without_tax = "";
          updatedErrors.strike_price_with_tax = "";
        }
        if (updatedForm.packageCharge.withTax > 0) {
          const amountWithoutTax = getReverseGst(
            String(updatedForm.gst),
            updatedForm.packageCharge.withTax
          );
          updatedForm.packageCharge.withoutTax = Number(
            amountWithoutTax.toFixed(2)
          );
        }
        setTouchedFields((prev) => ({ ...prev, ["gst"]: true }));
        return updatedForm;
      });
    },
    [form.gst]
  );

  const onMrpChange = useCallback((getData: { status: boolean }) => {
    setForm((prevForm) => {
      let updatedForm = { ...prevForm };
      let updatedErrors = { ...errors };

      const gstValue = parseFloat(prevForm.gst as any) || 0;
      const selectedMrp = parseFloat(prevForm?.selectedMrp?.mrp as any) || 0;
      const amountWithTax = getForwardGst(
        gstValue,
        prevForm.sellingPrice.withTax
      );
      if (getData.status) {
        console.log("selectedMrp :", selectedMrp);
        console.log("amountWithTax :", amountWithTax);
        if (selectedMrp > 0 && amountWithTax > selectedMrp) {
          updatedErrors.selling_price_without_tax = `Max : ${getReverseGst(
            gstValue,
            selectedMrp
          ).toFixed(2)}`;
          updatedErrors.selling_price_with_tax = `Max : ${selectedMrp.toFixed(
            2
          )}`;
        } else {
          updatedErrors.selling_price_without_tax = "";
          updatedErrors.selling_price_with_tax = "";
          updatedErrors.strike_price_without_tax = "";
          updatedErrors.strike_price_with_tax = "";
        }
      } else {
        updatedErrors.selling_price_without_tax = "";
        updatedErrors.selling_price_with_tax = "";
        updatedErrors.strike_price_without_tax = "";
        updatedErrors.strike_price_with_tax = "";
      }
      setErrors(updatedErrors);
      return updatedForm;
    });
  }, []);

  return (
    <div className="mt-3 mb-5">
      {/* Basic Details */}
      <div className="card shadow-md rounded-3 mt-3">
        <div className="card-body">
          <div className="fs-14px text-dark mb-3">Basic Details</div>
          <div className="mt-3">
            {/* Sector */}
            <div className="col-md-6">
              <InputField
                label="Sector"
                name="sector"
                type="select"
                required
                disabled
                options={allSectorData}
                value={form.sector}
                // onChange={(val) => {
                //   // handleChange("sector", val);
                //   // setForm((prevalue: any) => {
                //   //   prevalue.category = {};
                //   //   return prevalue;
                //   // });
                //   setForm((prev) => ({
                //     ...prev,
                //     sector: val,
                //     category: null, // reset category safely
                //   }));
                // }}
                onChange={handleSectorChange}
                error={errors.sector}
              />
            </div>
            {/* Category */}
            <div className="col-md-6">
              <InputField
                label="Category"
                name="category"
                type="select"
                required
                options={getCategoryOptions()}
                value={form.category}
                onChange={(val) => handleChange("category", val)}
                error={errors.category}
              />
            </div>
            {/* Product Name */}
            <div className="col-md-6">
              <InputField
                label="Product Name"
                name="name"
                type="text"
                required
                value={form.name}
                onChange={(val) => handleChange("name", val)}
                error={errors.name}
              />
            </div>
            {/* Product Description */}
            <div className="col-md-6">
              <InputField
                label="Product Desctiption"
                // name="description"
                type="text"
                // required
                value={form.description}
                onChange={(val) => handleChange("description", val)}
                error={errors.description}
              />
            </div>
            {/* Diet Type */}
            <div className="col-md-6">
              <InputField
                label="Diet Type"
                name="diet"
                type="select"
                options={getDietOptions(allDietTypeData)}
                value={form.diet}
                onChange={(val) => {
                  if (val.id == 0) {
                    setForm((prevalue: any) => {
                      let diet_spec_id: any = form?.specifications.find(
                        (ele: any) => ele.id == "115"
                      );
                      prevalue.spec_remove = [diet_spec_id?.product_spec_id];
                      prevalue.diet = {};
                      return { ...prevalue };
                    });
                    setTouchedFields((prev) => ({ ...prev, ["diet"]: true }));
                  } else {
                    handleChange("diet", val);
                  }
                }}
              />
            </div>
            {/* Product Image */}
            <div className="col-md-6">
              <div className="position-relative mb-3 w-100">
                <div className="outside-available radius-10 w-100">
                  <input
                    ref={fileInputRef}
                    className="outside FileInputNone"
                    type="file"
                    multiple
                    onChange={(evt: any) => {
                      // onFilesAdded(evt);
                    }}
                  />
                  <div className="p-3 w-100">
                    <div className="d-flex flex-wrap align-items-start gap-3">
                      {form.images.map((ele: any, index: any) => (
                        <div
                          key={`form-image-${index}`}
                          className="radius-6 pre-img-size me-2 mb-3 position-relative"
                        >
                          <div
                            className="cursor text-center text-red over-img-close-form"
                            onClick={() => {
                              // SetIsPDChanged(true);
                              setForm((prevalue: any) => {
                                prevalue.removed_images.push(ele);
                                prevalue.images.splice(index, 1);
                                return { ...prevalue };
                              });
                              setTouchedFields((prev) => ({
                                ...prev,
                                ["images"]: true,
                              }));
                            }}
                          >
                            ×
                          </div>
                          <img
                            src={AppHelper.imageSrc(imageBaseUrl, ele.url, {
                              format: "webp",
                              width: 320,
                            })}
                            className="pre-img-size"
                          />
                        </div>
                      ))}
                      {selectedImages?.map((element: any, index: any) => (
                        <div
                          key={`selected-image-${index}`}
                          className="radius-6 pre-img-size me-2 mb-3 position-relative"
                        >
                          <div
                            className="cursor text-center text-red over-img-close-form"
                            onClick={() => {
                              // setForm((prevValue: any) => {
                              //   let file_data = prevValue.selected_files;
                              //   file_data.splice(index, 1);
                              //   prevValue.selected_images = file_data;
                              //   return { ...prevValue };
                              // });
                              let send_data = {
                                index: index,
                              };
                              onRemoveImages(send_data);
                            }}
                          >
                            ×
                          </div>
                          <img
                            src={AppHelper.imageSrc(imageBaseUrl, element.url, {
                              format: "webp",
                              width: 320,
                            })}
                            className="pre-img-size"
                          />
                        </div>
                      ))}
                      {/* Image Add Button */}
                      <div
                        className="mt-3 border radius-6 bg-gray pre-img-size center"
                        onClick={() => {
                          // SetModalGallery((prevalue) => {
                          //   prevalue.is_open = true;
                          //   prevalue.from = "edit_product";
                          //   return { ...prevalue };
                          // });
                          let sendData = {
                            from: "edit_product",
                          };
                          onOpenFile(sendData);
                        }}
                      >
                        <img
                          src={
                            AppConfig.CDN_Media_url +
                            "47b9835dc6f13fad0481e35755afecd2.svg"
                          }
                          className="w-20"
                        />
                      </div>
                    </div>
                  </div>
                  <span className="floating-custom-label text-black">
                    Product Image
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Price Type Settings*/}
      <div className="card shadow-md rounded-3 mt-3">
        <div className="card-body">
          <div className="fs-14px text-dark">Settings</div>
          <div className="">
            {/* mrp */}
            <div className="d-flex center mt-3">
              <div className="fs-12px text-dark ">MRP</div>
              <div
                className="ms-auto in-stock-switch cursor"
                onClick={() => {
                  setPriceType((prevalue) => {
                    // setErrors((prevalue) => {
                    //   prevalue.strike_price_with_tax = "";
                    //   prevalue.strike_price_without_tax = "";
                    //   prevalue.selling_price_with_tax = "";
                    //   prevalue.selling_price_without_tax = "";
                    //   return { ...prevalue };
                    // });
                    prevalue.mrp = !prevalue.mrp;
                    let sendData = {
                      status: prevalue.mrp,
                    };
                    onMrpChange(sendData);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="checkbox"
                  className="matching-group-switch"
                  checked={priceType.mrp}
                  onChange={(event) => {
                    event.stopPropagation();
                  }}
                />
                <span className="slider"></span>
              </div>
            </div>

            {/* stock */}
            <div className="d-flex center mt-3">
              <div className="fs-12px text-dark ">Stock</div>
              <div
                className="ms-auto in-stock-switch cursor"
                onClick={() => {
                  setIsPriceTypeEdited(true);
                  setPriceType((prevalue: any) => {
                    if (!prevalue.stock == false) {
                      prevalue.stock_based_inventory = false;
                    }
                    prevalue.stock = !prevalue.stock;
                    let send_data = {
                      from: "stock",
                      status: prevalue.stock,
                    };
                    onPriceTypeToggle(send_data);
                    // process_view_card(send_data, prevalue);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="checkbox"
                  className="matching-group-switch"
                  checked={priceType.stock}
                  onChange={(event) => {
                    event.stopPropagation();
                  }}
                />
                <span className="slider"></span>
              </div>
            </div>

            {/* inventory */}
            <div className="d-flex center mt-3">
              <div className="fs-12px text-dark ">Inventory</div>
              <div
                className="ms-auto in-stock-switch cursor"
                onClick={() => {
                  setIsPriceTypeEdited(true);
                  setPriceType((prevalue: any) => {
                    if (!prevalue.inventory == false) {
                      prevalue.price_based_inventory = false;
                      prevalue.stock_based_inventory = false;
                    }
                    prevalue.inventory = !prevalue.inventory;
                    let send_data = {
                      from: "inventory",
                      status: prevalue.inventory,
                    };
                    onPriceTypeToggle(send_data);
                    // process_view_card(send_data, prevalue);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="checkbox"
                  className="matching-group-switch"
                  checked={priceType?.inventory}
                  onChange={(event) => {
                    console.log("onChange :", event.target);
                    event.stopPropagation();
                  }}
                />
                <span className="slider"></span>
              </div>
            </div>

            {/* price based inventory */}
            <div className="d-flex center mt-3">
              <div
                className={
                  priceType?.inventory
                    ? "fs-12px text-dark"
                    : "fs-12px text-gray"
                }
              >
                Price Based On Inventory ?
              </div>
              <div
                className="ms-auto in-stock-switch cursor"
                onClick={() => {
                  setIsPriceTypeEdited(true);
                  setPriceType((prevalue: any) => {
                    if (prevalue.inventory) {
                      prevalue.price_based_inventory =
                        !prevalue.price_based_inventory;
                    }
                    let send_data = {
                      from: "price_based_inventory",
                      status: prevalue.price_based_inventory,
                    };
                    onPriceTypeToggle(send_data);
                    // process_view_card(send_data, prevalue);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="checkbox"
                  className="matching-group-switch"
                  checked={priceType?.price_based_inventory}
                  disabled={!priceType?.inventory}
                  onChange={(event) => {
                    event.stopPropagation();
                  }}
                />
                <span className="slider"></span>
              </div>
            </div>

            {/* stock based inventory */}
            <div className="d-flex center mt-3">
              <div
                className={
                  priceType?.inventory
                    ? "fs-12px text-dark"
                    : "fs-12px text-gray"
                }
              >
                Stock Based On Inventory ?
              </div>
              <div
                className="ms-auto in-stock-switch cursor"
                onClick={() => {
                  setIsPriceTypeEdited(true);
                  setPriceType((prevalue: any) => {
                    if (prevalue.inventory && prevalue.stock) {
                      prevalue.stock_based_inventory =
                        !prevalue.stock_based_inventory;
                    } else {
                      console.log("stock is not checked");
                    }
                    let send_data = {
                      from: "stock_based_inventory",
                      status: prevalue.stock_based_inventory,
                    };
                    onPriceTypeToggle(send_data);
                    // process_view_card(send_data, prevalue);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="checkbox"
                  className="matching-group-switch"
                  checked={priceType?.stock_based_inventory}
                  disabled={!priceType?.stock && !priceType?.inventory}
                  onChange={(event) => {
                    event.stopPropagation();
                  }}
                />
                <span className="slider"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Price Details */}
      <div className="card shadow-md rounded-3 mt-3">
        <div className="card-body">
          <div className="fs-14px text-dark">Price Details</div>
          <div className="mt-3">
            {/* Mrp */}
            <div className="col-md-6">
              <InputField
                label="MRP"
                name="mrp"
                type="select"
                disabled={!priceType.mrp}
                options={form.mrp}
                value={form.selectedMrp}
                onChange={(val) => {
                  console.log("val :", val);
                  setForm((prevalue: any) => {
                    prevalue.selectedMrp = val;
                    return prevalue;
                  });
                  setPriceType((prevalue) => {
                    let sendData = {
                      status: prevalue.mrp,
                    };
                    onMrpChange(sendData);
                    return { ...prevalue };
                  });
                }}
              />
            </div>
            {/* Gst */}
            <div className="col-md-6">
              <InputField
                label="GST %"
                name="gst"
                type="number"
                value={Number(form.gst) > 0 ? form.gst : ""}
                onChange={(val) => {
                  // handleChange("gst", val);
                  let sendData = {
                    value: val,
                  };
                  onGstChange(sendData);
                }}
              />
            </div>
            {/* selling price */}
            <div className="">
              <p
                className={`${
                  !showSellingPrice(form) ? "text-gray" : "text-black"
                }`}
              >
                Selling Price
              </p>
              <div className="mt-3 d-flex align-items-center">
                <div className="pe-1 col-6">
                  <InputField
                    label="Without Tax ₹"
                    name="selling_price_without_tax"
                    type="number"
                    value={form.sellingPrice.withoutTax}
                    onChange={(val) => {
                      if (val == "") {
                        setForm((prevalue) => {
                          prevalue.sellingPrice.withoutTax = val;
                          prevalue.sellingPrice.withTax = val;
                          return { ...prevalue };
                        });
                      } else {
                        let senData = {
                          from: "selling_price_without_tax",
                          value: val,
                        };
                        onSellingPriceChange(senData);
                      }
                    }}
                    disabled={!showSellingPrice(form)}
                    error={errors.selling_price_without_tax}
                  />
                </div>
                <div className="ps-1 col-6">
                  <InputField
                    label="With Tax ₹"
                    name="selling_price_with_tax"
                    type="number"
                    value={form.sellingPrice.withTax}
                    onChange={(val) => {
                      if (val == "") {
                        setForm((prevalue) => {
                          prevalue.sellingPrice.withoutTax = val;
                          prevalue.sellingPrice.withTax = val;
                          return { ...prevalue };
                        });
                      } else {
                        let senData = {
                          from: "selling_price_with_tax",
                          value: val,
                        };
                        onSellingPriceChange(senData);
                      }
                    }}
                    disabled={!showSellingPrice(form)}
                    error={errors.selling_price_with_tax}
                  />
                </div>
              </div>
            </div>
            {/* strike price */}
            <div className="">
              <p
                className={`${
                  priceType.mrp || form.sellingPrice.withoutTax < 1
                    ? "text-gray"
                    : "text-black"
                }`}
              >
                Strike Price
              </p>
              <div className="mt-3 d-flex align-items-center">
                <div className="pe-1 col-6">
                  <InputField
                    label="Without Tax ₹"
                    name="strike_price_without_tax"
                    type="number"
                    disabled={priceType.mrp || form.sellingPrice.withoutTax < 1}
                    value={form.strikePrice.withoutTax}
                    onChange={(val) => {
                      if (val == "") {
                        setForm((prevalue) => {
                          prevalue.strikePrice.withoutTax = val;
                          prevalue.strikePrice.withTax = val;
                          return { ...prevalue };
                        });
                      } else {
                        let senData = {
                          from: "strike_price_without_tax",
                          value: val,
                        };
                        onStrikePriceChange(senData);
                      }
                    }}
                    error={errors.strike_price_without_tax}
                  />
                </div>
                <div className="ps-1 col-6">
                  <InputField
                    label="With Tax ₹"
                    name="strike_price_with_tax"
                    type="number"
                    disabled={priceType.mrp || form.sellingPrice.withoutTax < 1}
                    value={form.strikePrice.withTax}
                    onChange={(val) => {
                      if (val == "") {
                        setForm((prevalue) => {
                          prevalue.strikePrice.withoutTax = val;
                          prevalue.strikePrice.withTax = val;
                          return { ...prevalue };
                        });
                      } else {
                        let senData = {
                          from: "strike_price_with_tax",
                          value: val,
                        };
                        onStrikePriceChange(senData);
                      }
                    }}
                    error={errors.strike_price_with_tax}
                  />
                </div>
              </div>
              {errors.strike_price_without_tax ||
              errors.strike_price_with_tax ? (
                <div className="fs-10px text-red px-2 pb-2">
                  * Strike price must be higher than selling price
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {/* MRP list */}
      <div className="card shadow-md rounded-3 mt-4">
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">MRP</p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addMrp",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form?.mrp.map((ele: any, index: any) => (
            <>
              <div className="d-flex justify-content-between align-items-center bottom-line">
                <div>
                  <p className="text-dark center">S No</p>
                  <p className="text-dark center">{index + 1}</p>
                </div>
                <div>
                  <p className="text-dark center">Country</p>
                  <p className="text-dark center">{ele.country}</p>
                </div>
                <div>
                  <p className="text-dark center">MRP</p>
                  <p className="text-dark center">₹ {ele.mrp}</p>
                </div>
              </div>
              <hr />
            </>
          ))}
        </div>
      </div>
      {/* Stock list */}
      <div className="card shadow-md rounded-3 mt-4">
        {!viewCard.stock && (
          <div
            className="disabled-overlay position-absolute top-0 start-0 w-100 h-100 bg-light bg-opacity-70"
            style={{ zIndex: 1 }}
          ></div>
        )}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">Product Stock</p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addStock",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form.hasOwnProperty("stock") &&
          Object.keys(form?.stock).length > 0 ? (
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <p className="text-dark center">Available</p>
                <p className="text-dark center">
                  {form?.stock?.available_quantity}
                </p>
              </div>
              <div>
                <p className="text-dark center">Sold</p>
                <p className="text-dark center">{form?.stock?.sold_quantity}</p>
              </div>
              <div>
                <p className="text-dark center">Reserved</p>
                <p className="text-dark center">
                  {form?.stock?.reserved_quantity}
                </p>
              </div>
              <div>
                <p className="text-dark center">Returned</p>
                <p className="text-dark center">
                  {form?.stock?.returned_quantity}
                </p>
              </div>
            </div>
          ) : (
            <div>
              <p className="text-dark center">No Stock Available / Add Stock</p>
            </div>
          )}
        </div>
      </div>
      {/* Inventory list */}
      <div className="card shadow-md rounded-3 mt-4">
        {!viewCard.inventory && (
          <div
            className="disabled-overlay position-absolute top-0 start-0 w-100 h-100 bg-light bg-opacity-70"
            style={{ zIndex: 1 }}
          ></div>
        )}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">Inventory</p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addInventory",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form.hasOwnProperty("inventory") &&
          Object.keys(form?.inventory).length > 0 ? (
            form.inventory.map((ele: any) => (
              <>
                <div className="d-flex justify-content-between align-items-center bottom-line">
                  {/* id */}
                  <div>
                    <p className="text-dark center">ID</p>
                    <p className="text-dark center">{ele.id}</p>
                  </div>
                  {/* mrp / batch no */}
                  <div>
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">MRP</p>
                    ) : (
                      <p className="text-dark center">Batch No</p>
                    )}
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">₹ {ele.mrp}</p>
                    ) : (
                      <p className="text-dark center">{ele.batch_number}</p>
                    )}
                  </div>
                  {/* {ele.manufacturing_date && (
                    <div>
                      <p className="text-dark center">Manufacturing Date</p>
                      <p className="text-dark center">{ele.manufacturing_date}</p>
                    </div>
                  )} */}
                  {ele.expiry_date && (
                    <div>
                      <p className="text-dark center">Expiry Date</p>
                      <p className="text-dark center">{ele.expiry_date}</p>
                    </div>
                  )}
                  {/* Available */}
                  <div
                    className=""
                    onClick={() => {
                      let sendData = {
                        from: "invetory",
                        data: {
                          id: ele.id,
                          available: ele.available,
                          productData: productData,
                          groupData: groupData,
                        },
                      };
                      onAvailableChange(sendData);
                    }}
                  >
                    <p className="text-dark center">Available</p>
                    <div className="ms-auto in-stock-switch cursor">
                      <input
                        type="checkbox"
                        className="matching-group-switch"
                        checked={ele.available}
                        onChange={(event) => {
                          event.stopPropagation();
                        }}
                      />
                      <span className="slider"></span>
                    </div>
                  </div>
                </div>
                <hr />
              </>
            ))
          ) : (
            <div>
              <p className="text-dark center">
                No Inventory Available / Add Inventory
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Inventory With Selling Price list */}
      <div className="card shadow-md rounded-3 mt-4">
        {!viewCard.inventory_with_sp && (
          <div
            className="disabled-overlay position-absolute top-0 start-0 w-100 h-100 bg-light bg-opacity-70"
            style={{ zIndex: 1 }}
          ></div>
        )}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">
              Inventory With Selling Price
            </p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addInventoryWithSp",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form.hasOwnProperty("inventory") &&
          Object.keys(form?.inventoryBasedPrice).length > 0 ? (
            form.inventoryBasedPrice.map((ele: any) => (
              <>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-dark center">ID</p>
                    <p className="text-dark center">{ele.id}</p>
                  </div>
                  <div>
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">MRP</p>
                    ) : (
                      <p className="text-dark center">Batch No</p>
                    )}
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">₹ {ele.mrp}</p>
                    ) : (
                      <p className="text-dark center">{ele.batch_number}</p>
                    )}
                  </div>
                  <div>
                    <p className="text-dark center">Selling Price</p>
                    {form?.show_price_without_gst ? (
                      <p className="text-dark center">
                        {ele.price.price_without_tax}
                      </p>
                    ) : (
                      <p className="text-dark center">
                        {ele.price.price_with_tax}
                      </p>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      // SetInventoryEditBottomSheetData((prevalue: any) => {
                      //   prevalue.is_open = true;
                      //   let selected_in = edit_data?.inventoryBasedPrice.find(
                      //     (ele: any) => ele.available == true
                      //   );
                      //   prevalue.data = {
                      //     price: selected_in?.price,
                      //   };
                      //   prevalue.all_data = selected_in ? selected_in : {};
                      //   console.log("on open :", prevalue);
                      //   return { ...prevalue };
                      // });
                      let sendData = {
                        from: "editInventoryWithSp",
                        data: {
                          id: ele.id,
                        },
                        form_data: form,
                      };
                      triggerBottomSheet(sendData);
                    }}
                  >
                    <p className="text-dark center">Edit</p>
                    <img
                      src={
                        AppConfig.CDN_Media_url +
                        "9503435d1485f430f8d16efbf1b0ed0d.svg"
                      }
                      className="w-14px"
                    />
                  </div>
                  <div
                    onClick={() => {
                      // let send_data: any = {
                      //   inventory_id: ele.id,
                      // };
                      // if (ele.available) {
                      //   send_data.status = "off";
                      // } else {
                      //   send_data.status = "on";
                      // }
                      // send_data.product_type = edit_data.type;
                      // if (edit_data.type == "product") {
                      //   send_data.product_id = edit_data.product_id;
                      // } else {
                      //   send_data.product_id = edit_data.product_id;
                      // }
                      // SetSelectedOutlet((prevalue: any) => {
                      //   update_inventory_status(send_data, prevalue);
                      //   return { ...prevalue };
                      // });
                      let sendData = {
                        from: "invetoryWithSp",
                        data: {
                          id: ele.id,
                          available: ele.available,
                          productData: productData,
                          groupData: groupData,
                        },
                      };
                      onAvailableChange(sendData);
                    }}
                  >
                    <p className="text-dark center">Available</p>
                    <div className="ms-auto in-stock-switch cursor">
                      <input
                        type="checkbox"
                        className="matching-group-switch"
                        checked={ele.available}
                        onChange={(event) => {
                          event.stopPropagation();
                        }}
                      />
                      <span className="slider"></span>
                    </div>
                  </div>
                </div>
                <hr />
              </>
            ))
          ) : (
            <div>
              <p className="text-dark center">
                No Inventory With Selling Price Available / Add Inventory
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Inventory With Stock list */}
      <div className="card shadow-md rounded-3 mt-4">
        {!viewCard.inventory_with_stock && (
          <div
            className="disabled-overlay position-absolute top-0 start-0 w-100 h-100 bg-light bg-opacity-70"
            style={{ zIndex: 1 }}
          ></div>
        )}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">
              Inventory With Stock
            </p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addInventoryWithStock",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form.hasOwnProperty("inventory") &&
          Object.keys(form?.inventoryBasedStock).length > 0 ? (
            form.inventoryBasedStock.map((ele: any) => (
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-dark center">ID</p>
                    <p className="text-dark center">{ele.id}</p>
                  </div>
                  <div>
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">MRP</p>
                    ) : (
                      <p className="text-dark center">Batch No</p>
                    )}
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">₹ {ele.mrp}</p>
                    ) : (
                      <p className="text-dark center">{ele.batch_number}</p>
                    )}
                  </div>
                  <div
                    className=""
                    onClick={() => {
                      // let send_data: any = {
                      //   inventory_id: ele.id,
                      // };
                      // if (ele.available) {
                      //   send_data.status = "off";
                      // } else {
                      //   send_data.status = "on";
                      // }
                      // send_data.product_type = edit_data.type;
                      // if (edit_data.type == "product") {
                      //   send_data.product_id = edit_data.product_id;
                      // } else {
                      //   send_data.product_id = edit_data.product_id;
                      // }
                      // SetSelectedOutlet((prevalue: any) => {
                      //   update_inventory_status(send_data, prevalue);
                      //   return { ...prevalue };
                      // });
                      let sendData = {
                        from: "invetoryWithStock",
                        data: {
                          id: ele.id,
                          available: ele.available,
                          productData: productData,
                          groupData: groupData,
                        },
                      };
                      onAvailableChange(sendData);
                    }}
                  >
                    <p className="text-dark center">Available</p>
                    <div className="ms-auto in-stock-switch cursor">
                      <input
                        type="checkbox"
                        className="matching-group-switch"
                        checked={ele.available}
                        onChange={(event) => {
                          event.stopPropagation();
                        }}
                      />
                      <span className="slider"></span>
                    </div>
                  </div>
                </div>
                <p className="text-dark fs-14px">Stock</p>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-dark center">Available</p>
                    <p className="text-dark center">
                      {ele?.stock?.available_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Sold</p>
                    <p className="text-dark center">
                      {ele?.stock?.sold_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Reserved</p>
                    <p className="text-dark center">
                      {ele?.stock?.reserved_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Returned</p>
                    <p className="text-dark center">
                      {ele?.stock?.returned_quantity}
                    </p>
                  </div>
                </div>
                <hr />
              </div>
            ))
          ) : (
            <div>
              <p className="text-dark center">
                No Inventory With Stock Available / Add Inventory
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Inventory With Stock & Selling Price list */}
      <div className="card shadow-md rounded-3 mt-4">
        {!viewCard.inventory_with_stock_sp && (
          <div
            className="disabled-overlay position-absolute top-0 start-0 w-100 h-100 bg-light bg-opacity-70"
            style={{ zIndex: 1 }}
          ></div>
        )}
        <div className="card-header">
          <div className="d-flex justify-content-between align-items-center flex-wrap">
            <p className="fw-semibold fs-12px text-dark ">
              Inventory With Stock & Selling Price
            </p>
            <div
              className="ms-auto"
              onClick={() => {
                let sendData = {
                  from: "addInventoryWithSpStock",
                  form_data: form,
                };
                triggerBottomSheet(sendData);
              }}
            >
              <img
                src={
                  AppConfig.CDN_Media_url +
                  "7767d0d4cacda6a7c1cee478a6cf447c.svg"
                }
                className="w-14px"
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          {form.hasOwnProperty("inventory") &&
          Object.keys(form?.inventoryBasedStockPrice).length > 0 ? (
            form.inventoryBasedStockPrice.map((ele: any) => (
              <div>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-dark center">ID</p>
                    <p className="text-dark center">{ele.id}</p>
                  </div>
                  <div>
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">MRP</p>
                    ) : (
                      <p className="text-dark center">Batch No</p>
                    )}
                    {ele.inventory_type_id == 1 ? (
                      <p className="text-dark center">₹ {ele.mrp}</p>
                    ) : (
                      <p className="text-dark center">{ele.batch_number}</p>
                    )}
                  </div>
                  <div>
                    <p className="text-dark center">Selling Price</p>
                    {form.show_price_without_gst ? (
                      <p className="text-dark center">
                        {ele.price.price_without_tax}
                      </p>
                    ) : (
                      <p className="text-dark center">
                        {ele.price.price_with_tax}
                      </p>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      // SetInventoryEditBottomSheetData((prevalue: any) => {
                      //   prevalue.is_open = true;
                      //   let selected_in =
                      //     edit_data?.inventoryBasedStockPrice.find(
                      //       (ele: any) => ele.available == true
                      //     );
                      //   prevalue.data = {
                      //     price: selected_in?.price,
                      //   };
                      //   prevalue.all_data = selected_in ? selected_in : {};
                      //   console.log("on open :", prevalue);
                      //   return { ...prevalue };
                      // });
                      let sendData = {
                        from: "editInventoryWithSpStock",
                        data: {
                          id: ele.id,
                        },
                        form_data: form,
                      };
                      triggerBottomSheet(sendData);
                    }}
                  >
                    <p className="text-dark center">Edit</p>
                    <img
                      src={
                        AppConfig.CDN_Media_url +
                        "9503435d1485f430f8d16efbf1b0ed0d.svg"
                      }
                      className="w-14px"
                    />
                  </div>
                  <div
                    onClick={() => {
                      // let send_data: any = {
                      //   inventory_id: ele.id,
                      // };
                      // if (ele.available) {
                      //   send_data.status = "off";
                      // } else {
                      //   send_data.status = "on";
                      // }
                      // send_data.product_type = edit_data.type;
                      // if (edit_data.type == "product") {
                      //   send_data.product_id = edit_data.product_id;
                      // } else {
                      //   send_data.product_id = edit_data.product_id;
                      // }
                      // SetSelectedOutlet((prevalue: any) => {
                      //   update_inventory_status(send_data, prevalue);
                      //   return { ...prevalue };
                      // });
                      let sendData = {
                        from: "invetoryWithStockSp",
                        data: {
                          id: ele.id,
                          available: ele.available,
                          productData: productData,
                          groupData: groupData,
                        },
                      };
                      onAvailableChange(sendData);
                    }}
                  >
                    <p className="text-dark center">Available</p>
                    <div className="ms-auto in-stock-switch cursor">
                      <input
                        type="checkbox"
                        className="matching-group-switch"
                        checked={ele.available}
                        onChange={(event) => {
                          event.stopPropagation();
                        }}
                      />
                      <span className="slider"></span>
                    </div>
                  </div>
                </div>
                <p className="text-dark fs-14px">Stock</p>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <p className="text-dark center">Available</p>
                    <p className="text-dark center">
                      {ele?.stock?.available_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Sold</p>
                    <p className="text-dark center">
                      {ele?.stock?.sold_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Reserved</p>
                    <p className="text-dark center">
                      {ele?.stock?.reserved_quantity}
                    </p>
                  </div>
                  <div>
                    <p className="text-dark center">Returned</p>
                    <p className="text-dark center">
                      {ele?.stock?.returned_quantity}
                    </p>
                  </div>
                </div>
                <hr />
              </div>
            ))
          ) : (
            <div>
              <p className="text-dark center">
                No Inventory With Stock And Stock Available / Add Inventory
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Packaging Charges */}
      <div className="card shadow-md rounded-3 mt-4 mb-5">
        <div className="card-body">
          <div className="fs-14px text-dark">Packaging Charges</div>
          <div className="mt-3">
            <div className="d-flex mt-3 w-100">
              <div
                // className={
                //   form?.packageCharge?.type == 2
                //     ? "me-1 pc-type-radio w-50 bg-blue-500 text-white"
                //     : "me-1 pc-type-radio w-50"
                // }
                className={`text-center me-1 pc-type-radio w-50 ${
                  form?.packageCharge?.type == 2 && "bg-blue-500 text-white"
                }`}
                onClick={() => {
                  setForm((prevalue) => {
                    prevalue.packageCharge.type = 2;
                    // prevalue.packageCharge.withTax = 0;
                    // prevalue.packageCharge.withoutTax = 0;
                    let sendData = {
                      from: "gst",
                      value: prevalue.packageCharge.gst,
                    };
                    onPackagePriceChange(sendData);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="radio"
                  value={2}
                  checked={form?.packageCharge?.type == 2}
                  className="mr-2"
                />
                Fixed Charges
              </div>

              <div
                // className={
                //   form?.packageCharge?.type == 1
                //     ? "ms-1 pc-type-radio w-50 bg-blue-500 text-white"
                //     : "ms-1 pc-type-radio w-50"
                // }
                className={`text-center ms-1 pc-type-radio w-50 ${
                  form?.packageCharge?.type == 1 && "bg-blue-500 text-white"
                }`}
                onClick={() => {
                  setForm((prevalue) => {
                    prevalue.packageCharge.type = 1;
                    // prevalue.packageCharge.withTax = 0;
                    // prevalue.packageCharge.withoutTax = 0;
                    let sendData = {
                      from: "percentage",
                      value: prevalue.packageCharge.percentage,
                    };
                    onPackagePriceChange(sendData);
                    return { ...prevalue };
                  });
                }}
              >
                <input
                  type="radio"
                  value={1}
                  checked={form?.packageCharge?.type == 1}
                  className="mr-2"
                />
                Percentage Charges
              </div>
            </div>
            {/* GST / Percentage */}
            <div className="mt-3 d-flex align-items-center">
              <div
                className={
                  form?.packageCharge?.type == 1 ? "pe-1 col-6" : "col-12"
                }
              >
                <InputField
                  label="Packaging GST %"
                  name="pc_gst"
                  type="number"
                  value={
                    form?.packageCharge?.gst > 0 ? form?.packageCharge?.gst : ""
                  }
                  onChange={(val) => {
                    // setForm((prevalue: any) => {
                    //   prevalue.strikePrice.withoutTax = val;
                    //   return prevalue;
                    // });
                    let sendData = {
                      from: "gst",
                      value: val,
                    };
                    onPackagePriceChange(sendData);
                  }}
                />
              </div>
              {form?.packageCharge?.type == 1 && (
                <div className="ps-1 col-6">
                  <InputField
                    label="Packaging %"
                    name="pc_percentage"
                    type="number"
                    value={form?.packageCharge?.percentage}
                    onChange={(val) => {
                      // setForm((prevalue: any) => {
                      //   prevalue.strikePrice.withTax = val;
                      //   return prevalue;
                      // });
                      let sendData = {
                        from: "percentage",
                        value: val,
                      };
                      onPackagePriceChange(sendData);
                    }}
                  />
                </div>
              )}
            </div>
            {/* amount with / without tax */}
            <div className="mt-2 d-flex align-items-center">
              <div className="pe-1 col-6">
                <InputField
                  label="Without Tax ₹"
                  name="pc_price_without_tax"
                  type="number"
                  disabled={form?.packageCharge.type == 1 ? true : false}
                  value={form?.packageCharge?.withoutTax}
                  onChange={(val) => {
                    // setForm((prevalue: any) => {
                    //   prevalue.strikePrice.withoutTax = val;
                    //   return prevalue;
                    // });
                    let sendData = {
                      from: "withoutTax",
                      value: val,
                    };
                    onPackagePriceChange(sendData);
                  }}
                />
              </div>
              <div className="ps-1 col-6">
                <InputField
                  label="With Tax ₹"
                  name="pc_price_with_tax"
                  type="number"
                  disabled={form?.packageCharge.type == 1 ? true : false}
                  value={form?.packageCharge?.withTax}
                  onChange={(val) => {
                    // setForm((prevalue: any) => {
                    //   prevalue.strikePrice.withTax = val;
                    //   return prevalue;
                    // });
                    let sendData = {
                      from: "withTax",
                      value: val,
                    };
                    onPackagePriceChange(sendData);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Button */}
      <div className="mt-5 mb-2 fix-bottom">
        <button
          className={"primary-button"}
          // className={validateForm() ? "primary-button" : "disabled-button"}
          // disabled={!validateForm()}
          onClick={handleSubmit}
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default ProductForm;
